import dayjs from 'dayjs';

import type {CoachOrClientTaskApiModel} from '../../../api/task/types';
import type {Nullable} from '../../utility-types';

import {not} from '../../conditionalUtils';
import {datetimeObjToISOString} from '../../datetime';
import {isDefined} from '../../typecheck';
import {isTaskDone} from './isTaskDone';

export const isTaskOverdue = (task?: Nullable<CoachOrClientTaskApiModel>) =>
  isDefined(task)
    ? not(isTaskDone(task)) &&
      dayjs() > dayjs(datetimeObjToISOString(task.end_date))
    : false;
